import React from 'react'
import PropTypes from 'prop-types'
import { makeFlexContainer } from './styled'

export const PureFlexContainer = makeFlexContainer('div')

export function RawFlexContainer(props) {
  return <PureFlexContainer {...props} />
}

function FlexContainer(props) {
  return <RawFlexContainer {...props} />
}

FlexContainer.propTypes = {
  disabled: PropTypes.bool,
  href: PropTypes.string,
  flexible: PropTypes.bool,
  thin: PropTypes.bool,
  secondary: PropTypes.bool,
  emphasis: PropTypes.bool,
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
}

FlexContainer.defaultProps = {
  disabled: false,
}

export default FlexContainer
